import { createContext, ReactNode, useContext, useState } from "react";

interface CombinedLoadingsContextType {
  combinedLoading: boolean;
  setCombinedLoading: (loading: boolean) => void;
  forceStopLoading: () => void;
}

interface Props {
  children: ReactNode;
  userLoading: boolean;
  dashboardLoading: boolean;
  schoolsLoading: boolean;
  studentsLoading: boolean;
}

const CombinedLoadingContext = createContext<
  CombinedLoadingsContextType | undefined
>(undefined);

export const CombinedLoadingsProvider = ({
  children,
  userLoading,
  dashboardLoading,
  schoolsLoading,
  studentsLoading,
}: Props) => {
  const [manualLoadingOverride, setManualLoadingOverride] = useState<
    boolean | null
  >(null);

  const combinedLoading =
    manualLoadingOverride !== null
      ? manualLoadingOverride
      : userLoading || dashboardLoading || schoolsLoading || studentsLoading;

  const setCombinedLoading = (loading: boolean) => {
    setManualLoadingOverride(loading);
  };

  const forceStopLoading = () => {
    setManualLoadingOverride(false);
  };

  return (
    <CombinedLoadingContext.Provider
      value={{
        combinedLoading,
        setCombinedLoading,
        forceStopLoading,
      }}
    >
      {children}
    </CombinedLoadingContext.Provider>
  );
};

export const useCombinedLoadingContext = () => {
  const context = useContext(CombinedLoadingContext);
  if (!context) {
    throw new Error(
      "useCombinedLoadingContext must be used within a CombinedLoadingProvider"
    );
  }
  return context;
};
